import dayjs from "dayjs";
import pt from "dayjs/locale/pt.js";

dayjs.locale("pt");

export default {
  ...pt,
  customFormats: {
    Ll: "D MMM. YYYY",
    Lwy: "D [de] MMMM [del] YYYY",
  },
  hours_short: "h",
  minutes_short: "min",
};
